import React from "react";
import {
  LogoIcon,
  FooterBackground
} from "../styles/componentStyled";
import { Box, Container, Typography } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import { Link } from "react-router-dom";

const OptionsLogo = () => (
  <SettingsIcon sx={{
    fontSize: '40px',
    color: 'white',
    transition: 'transform 0.2s ease-in-out',
    '&:hover': {
      transform: 'scale(1.03)',
      color: '#00FBF4'
    }
  }} />)


const Footer = () => {
  return (
    <FooterBackground
      // @ts-ignore
      component="footer"
    >
      <Container maxWidth="lg" sx={{ padding: "34px 30px !important" }}>
        {" "}
        <Box
          sx={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <LogoIcon
            component="img"
            src="/images/top500-logo.png"
            alt="AI Trader Logo"
          />
          {/* <Link to={'/post-list'}>
          <OptionsLogo
          />
          </Link> */}
        </Box>
        <Box component="hr" />
        <Typography variant="subtitle2" textAlign="right">
          © Copyright 2024. All Rights Reserved.
        </Typography>
      </Container>
    </FooterBackground>
  );
};

export default Footer;
